import { Container, Paper, Stack, Typography } from '@mui/material'
import {} from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router'

export default function ErrorBoundary() {
  const error = useRouteError()
  if (isRouteErrorResponse(error)) {
    return (
      <Container maxWidth="sm">
        <Stack spacing={4} sx={{ height: '100vh', pt: '20vh' }}>
          <Typography variant="h1">
            {error.status} {error.statusText}
          </Typography>
          <Typography>{error.data}</Typography>
        </Stack>
      </Container>
    )
  }
  if (error instanceof Error) {
    return (
      <Container maxWidth="sm">
        <Stack spacing={4} sx={{ height: '100vh', pt: '20vh' }}>
          <Typography variant="h1">Something went wrong</Typography>
          <Stack>
            <Typography variant="caption">People make mistakes.</Typography>
            <Typography variant="caption">We're sorry for the inconvenience.</Typography>
          </Stack>
          <Typography>
            Error: <code>{error.message}</code>
          </Typography>
          <details>
            <summary>Show details</summary>
            <Paper sx={{ p: 2 }}>
              <code>
                <pre>{error.message}</pre>
                <pre>{error.stack}</pre>
              </code>
            </Paper>
          </details>
        </Stack>
      </Container>
    )
  }
  return (
    <Container maxWidth="sm">
      <Stack spacing={4} sx={{ height: '100vh', pt: '20vh' }}>
        <Typography variant="h1">Unknown error went bonk</Typography>
        <Stack>
          <Typography variant="caption">People make mistakes.</Typography>
          <Typography variant="caption">We're sorry for the inconvenience.</Typography>
        </Stack>
      </Stack>
    </Container>
  )
}
